<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Warehouse
            <div class="settings-header__btn">
              <el-button
              type="success"
              size="mini"
              @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <div class="setting-component">
            <div class="wrap">
              <div class="wrap__tree">

                <div class="nav-tree">
                  <el-button
                  @click="openModalCreate"
                  class="nav-tree__item"
                  size="mini"
                  type="primary"
                  plain
                  icon="el-icon-plus">Add Warehouse</el-button>
                </div>

                <el-table
                  max-height="650"
                  :data="tableData"
                  @cell-click="cellClick"
                  :empty-text="$t('general_noData')"
                  style="width: 100%">
                  <el-table-column
                    label="ID"
                    type="index"
                    align="center"
                    width="70">
                  </el-table-column>
                  <el-table-column
                    prop="warehouseCode"
                    :label="$t('settings_accountThink_inventory_warehouseCode')"
                    width="160">
                  </el-table-column>
                  <el-table-column
                    prop="warehouseName"
                    :label="$t('settings_accountThink_inventory_warehouseName')">
                  </el-table-column>
                  <el-table-column
                    align="center"
                    :label="$t('settings_accountThink_inventory_contactForDeliveries')">
                    <template slot-scope="scope">
                      <span v-text="scope.row.manager ? scope.row.manager.fullName : null"></span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="Assigned BU">
                    <template slot-scope="scope">
                      <span v-text="scope.row.businessUnit ? scope.row.businessUnit.name : null"></span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="Assigned Projects">
                    <template slot-scope="scope">
                      <span v-text="scope.row.project ? scope.row.project.name : null"></span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    label="Created On"
                    align="center">
                    <template slot-scope="scope">
                      <div>{{ moment(scope.row.createdAt).format("D MMM YYYY") }}</div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    label="History"
                    align="center">
                    <template slot-scope="scope">
                      <div @click="setHistory(scope.row)" style="display: flex; justify-content: center; align-items: center; cursor: pointer;">
                        <img src="@/assets/img/history.png" alt="History" height="24px">
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    align="center"
                    :label="$t('settings_accountThink_inventory_operations')">
                    <template slot-scope="scope">
                      <el-button
                        size="mini"
                        type="primary"
                        plain
                        icon="el-icon-edit"
                        @click="handleUpdate(scope.row)"></el-button>
                      <el-button
                        size="mini"
                        type="danger"
                        plain
                        icon="el-icon-delete"
                        @click="handleDelete(scope.row)"></el-button>
                    </template>
                  </el-table-column>
                </el-table>

              </div>
            </div>

            <create-update-modal @loadList="loadList" ref="createUpdateModal"></create-update-modal>
            <modal-history :historyList='historyList' ref="openHistory"></modal-history>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import CreateUpdateModal from '@/components/settings/organisationDesign/warehouse/CreateUpdateModal.vue'
  import ModalHistory from '@/components/journalAndGl/historyJournalEntry.vue'

  export default {
    name: "warehouse",
    components: {
      CreateUpdateModal,
      ModalHistory,
    },
    data() {
      return {
        tableData: [],
        historyList: [],
        moment:moment,
      }
    },
    mounted() {
      this.loadList()
    },
    methods: {
      async loadList(){
        let loader = this.$loading.show();
        try {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          const { data } = await axios.post(`/api/v1/inventories/list?companyId=${this.$route.query.companyId}`)
          this.tableData = data.inventoryList
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      openModalCreate(){
        this.$refs.createUpdateModal.openModal({ isCreate: true })
      },
      handleUpdate(row) {
        this.$refs.createUpdateModal.openModal({ isCreate: false, row })
      },
      async handleDelete(row) {
        this.$confirm('This will permanently delete. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(async () => {
          let loader = this.$loading.show();
          try {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            await axios.post(`/api/v1/inventories/delete?companyId=${this.$route.query.companyId}&id=${row.id}`)
            await this.loadList()
            loader.hide()
            this.$message({ type: 'success', message: 'Delete completed' });
          } catch (error) {
            console.log('An error occurred:', error);
            loader.hide()
          }

        }).catch(() => {
          this.$message({ type: 'info', message: 'Delete canceled' });
        });
      },
      async setHistory(row) {
        let loader = this.$loading.show();
        try {
          const { data } = await axios.get(`/api/v1/inventories/item-history?companyId=${this.$route.query.companyId}&id=${row.id}`)
          this.historyList = data.list
          this.$refs.openHistory.openModal()
          loader.hide()
        } catch (error) {
          console.log('An error occurred:', error);
          loader.hide()
        }
      },
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      },
      cellClick (row, column, cell, event) {
        if (column.label !== 'Action' && column.label !== 'History') {
          this.$refs.createUpdateModal.openModal({ isCreate: false, row, onlyInfo: true })
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}
.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
